var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeLinedIconMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0028 19L11.9998 19C11.6696 19.001 11.3425 18.9353 11.0376 18.8065C10.7327 18.6777 10.4561 18.4884 10.2244 18.2494L10.2222 18.247L2.56395 10.3999C2.56342 10.3994 2.5629 10.3988 2.56237 10.3983C1.56132 9.36193 1 7.97165 1 6.52281C1 5.07398 1.56132 3.68369 2.56236 2.64735C3.07201 2.12542 3.67929 1.71122 4.34864 1.42854C5.01868 1.14557 5.7377 0.999953 6.46382 1C7.18994 1.00005 7.90895 1.14576 8.57895 1.42881C9.24896 1.71188 9.85676 2.12672 10.3667 2.6495L10.3667 2.64953L11.2876 3.59356L12.0034 4.32737L12.7192 3.59355L13.6395 2.65013L13.6415 2.64807C14.1493 2.12459 14.7557 1.70947 15.4248 1.42693C16.0939 1.1444 16.8122 1.00008 17.5373 1.00236H17.5404L17.5428 1.00236L17.5455 1.00235C18.271 1.00045 18.9896 1.14527 19.6589 1.42841C20.3279 1.71146 20.9343 2.12707 21.4417 2.651C22.4405 3.68687 23.0003 5.07551 23 6.52238C22.9997 7.96882 22.4398 9.35684 21.4411 10.3922C21.4406 10.3928 21.44 10.3934 21.4395 10.3939L13.7838 18.2468L13.7816 18.249C13.5496 18.4884 13.2736 18.6777 12.9691 18.8063L13.3584 19.7274L12.9691 18.8063C12.6643 18.9352 12.3371 19.001 12.007 19H12.004L12.0028 19Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeLinedIconMob);
export default __webpack_public_path__ + "static/media/like-lined-icon-mob.097410e3d291c9e3b9ec6904fcc5f03e.svg";
export { ForwardRef as ReactComponent };